// ⚠️ ARQUIVO GERADO — não editar à mão.
// Fonte: docs/legislacao/RDC-1036-2026-Anexo-I-Portaria-344-atualizacao-101.txt
// RDC Anvisa nº 1.036, de 9 de julho de 2026 — Anexo I, Atualização n. 101.
// Regerar: node ferramentas/gerar-listas-portaria344.mjs
// (B356 passo 1, AI_154)

export type ListaPortaria344 = "A1" | "A2" | "A3" | "B1" | "B2" | "C1" | "C2" | "C3" | "C5";

export const FONTE_LISTAS_344 = {
  rdc: "RDC Anvisa nº 1.036/2026",
  atualizacao: 101,
  arquivo: "docs/legislacao/RDC-1036-2026-Anexo-I-Portaria-344-atualizacao-101.txt",
} as const;

/** Nº de itens numerados por lista no texto oficial (conferido em teste). */
export const ITENS_POR_LISTA_344: Record<ListaPortaria344, number> = {
  A1: 94,
  A2: 13,
  A3: 14,
  B1: 95,
  B2: 8,
  C1: 213,
  C2: 5,
  C3: 3,
  C5: 31,
};

/** Grafias (item + sinônimos) de cada lista, na forma do texto oficial. */
export const LISTAS_344: Record<ListaPortaria344, readonly string[]> = {
  A1: [
    "Acetilmetadol",
    "Alfacetilmetadol",
    "Alfameprodina",
    "Alfametadol",
    "Alfaprodina",
    "Alfentanila",
    "Alilprodina",
    "Anileridina",
    "Bezitramida",
    "Benzetidina",
    "Benzilmorfina",
    "Benzoilmorfina",
    "Betacetilmetadol",
    "Betameprodina",
    "Betametadol",
    "Betaprodina",
    "Buprenorfina",
    "Butorfanol",
    "Clonitazeno",
    "Codoxima",
    "Concentrado de palha de dormideira",
    "Dextromoramida",
    "Diampromida",
    "Dietiltiambuteno",
    "Difenoxilato",
    "Difenoxina",
    "Diidromorfina",
    "metadol",
    "Dimefeptanol",
    "Dimenoxadol",
    "Dimetiltiambuteno",
    "Dioxafetila",
    "Dipipanona",
    "Drotebanol",
    "Etilmetiltiambuteno",
    "Etonitazeno",
    "Etoxeridina",
    "Fenadoxona",
    "Fenampromida",
    "Fenazocina",
    "Fenomorfano",
    "Fenoperidina",
    "Fentanila",
    "Furetidina",
    "Hidrocodona",
    "Hidromorfinol",
    "Hidromorfona",
    "Hidroxipetidina",
    "Intermediário da metadona",
    "Intermediário da moramida",
    "Intermediário \"a\" da petidina",
    "Intermediário \"b\" da petidina",
    "Intermediário \"c\" da petidina",
    "Isometadona",
    "Levofenacilmorfano",
    "Levometorfano",
    "Levomoramida",
    "Levorfanol",
    "Metadona",
    "Metazocina",
    "Metildesorfina",
    "Metildiidromorfina",
    "Metopona",
    "Mirofina",
    "Morferidina",
    "Morfina",
    "Morinamida",
    "Nicomorfina",
    "Noracimetadol",
    "Norlevorfanol",
    "Normetadona",
    "Normorfina",
    "Norpipanona",
    "N-oxicodeína",
    "N-oximorfina",
    "Ópio",
    "Oripavina",
    "Oxicodona",
    "Oximorfona",
    "Petidina",
    "Piminodina",
    "Piritramida",
    "Proeptazina",
    "Properidina",
    "Racemetorfano",
    "Racemoramida",
    "Racemorfano",
    "Remifentanila",
    "Sufentanila",
    "Tapentadol",
    "Tebacona",
    "Tebaína",
    "Tilidina",
    "Trimeperidina",
    "Viminol",
  ],
  A2: [
    "Acetildiidrocodeina",
    "Codeína",
    "Dextropropoxifeno",
    "Diidrocodeína",
    "Etilmorfina",
    "Folcodina",
    "Nalbufina",
    "Nalorfina",
    "Nicocodina",
    "Nicodicodina",
    "Norcodeína",
    "Propiram",
    "Tramadol",
  ],
  A3: [
    "Anfetamina",
    "Catina",
    "Clorfentermina",
    "Dexanfetamina",
    "Dronabinol",
    "Femetrazina",
    "Fenciclidina",
    "Fenetilina",
    "Fenfluramina",
    "Levanfetamina",
    "Lisdexanfetamina",
    "Metilfenidato",
    "Metilsinefrina",
    "Tanfetamina",
  ],
  B1: [
    "Alfaxalona",
    "Alobarbital",
    "Alprazolam",
    "Amineptina",
    "Amobarbital",
    "Aprobarbital",
    "Armodafinila",
    "Barbexaclona",
    "Barbital",
    "Bromazepam",
    "Bromazolam",
    "Brotizolam",
    "Butabarbital",
    "Butalbital",
    "Camazepam",
    "Carisoprodol",
    "Cetamina",
    "Cetazolam",
    "Ciclobarbital",
    "Clobazam",
    "Clonazepam",
    "Clonazolam",
    "Clorazepam",
    "Clorazepato",
    "Clordiazepóxido",
    "Cloreto de etila",
    "Cloreto de metileno/diclorometano",
    "Clotiazepam",
    "Cloxazolam",
    "Delorazepam",
    "Diazepam",
    "Diclazepam",
    "Escetamina",
    "Estazolam",
    "Eszopiclona",
    "Etclorvinol",
    "N-etilanfetamina",
    "Etilanfetamina",
    "Etinamato",
    "Etizolam",
    "Fenazepam",
    "Fenobarbital",
    "Flualprazolam",
    "Flubromazolam",
    "Fludiazepam",
    "Flunitrazepam",
    "Flunitrazolam",
    "Flurazepam",
    "GBL",
    "ácido gama-hidroxibutírico",
    "GHB",
    "Glutetimida",
    "Halazepam",
    "Haloxazolam",
    "Lefetamina",
    "Lemborexante",
    "Loflazepato de etila",
    "Loprazolam",
    "Lorazepam",
    "Lormetazepam",
    "Medazepam",
    "Meprobamato",
    "Mesocarbo",
    "prominal",
    "Metilfenobarbital",
    "Metiprilona",
    "Midazolam",
    "Modafinila",
    "Nimetazepam",
    "Nitrazepam",
    "fencanfamina",
    "Norcanfano",
    "Nordazepam",
    "Oxazepam",
    "Oxazolam",
    "Pemolina",
    "Pentazocina",
    "Pentobarbital",
    "Perampanel",
    "Pinazepam",
    "Pipradrol",
    "Pirovalerona",
    "Prazepam",
    "Prolintano",
    "Propilexedrina",
    "Remimazolam",
    "Secbutabarbital",
    "Secobarbital",
    "Temazepam",
    "Tetrazepam",
    "Tiamilal",
    "Tiopental",
    "Triazolam",
    "Tricloroetileno",
    "Triexifenidil",
    "Vinilbital",
    "Zaleplona",
    "Zolpidem",
    "Zopiclona",
  ],
  B2: [
    "Aminorex",
    "Anfepramona",
    "Femproporex",
    "Fendimetrazina",
    "Fentermina",
    "Mazindol",
    "Mefenorex",
    "Sibutramina",
  ],
  C1: [
    "Acepromazina",
    "Ácido valpróico",
    "Agomelatina",
    "Amantadina",
    "Amissulprida",
    "Amitriptilina",
    "Amoxapina",
    "Aripiprazol",
    "Asenapina",
    "Atomoxetina",
    "Azaciclonol",
    "Beclamida",
    "Benactizina",
    "Benfluorex",
    "Benzidamina",
    "Benzoctamina",
    "Benzoquinamida",
    "Biperideno",
    "Brexpiprazol",
    "Brivaracetam",
    "Bupropiona",
    "Buspirona",
    "Butaperazina",
    "Butriptilina",
    "Canabidiol",
    "Captodiamo",
    "Carbamazepina",
    "Caroxazona",
    "Celecoxibe",
    "Cenobamato",
    "Ciclarbamato",
    "Ciclexedrina",
    "Ciclopentolato",
    "Cisaprida",
    "Citalopram",
    "Clomacrano",
    "Clometiazol",
    "Clomipramina",
    "Clorexadol",
    "Clorpromazina",
    "Clorprotixeno",
    "Clotiapina",
    "Clozapina",
    "Dapoxetina",
    "Desflurano",
    "Desipramina",
    "Desvenlafaxina",
    "Deutetrabenazina",
    "Dexetimida",
    "Dexmedetomidina",
    "Dibenzepina",
    "Dimetracrina",
    "Disopiramida",
    "Dissulfiram",
    "Divalproato de sódio",
    "Dixirazina",
    "Donepezila",
    "Doxepina",
    "Droperidol",
    "Duloxetina",
    "Ectiluréia",
    "Emilcamato",
    "Enflurano",
    "Entacapona",
    "Escitalopram",
    "Estiripentol",
    "Etomidato",
    "Etoricoxibe",
    "Etossuximida",
    "Facetoperano",
    "Femprobamato",
    "Fenaglicodol",
    "Fenelzina",
    "Feniprazina",
    "Fenitoina",
    "Flufenazina",
    "Flumazenil",
    "Fluoxetina",
    "Flupentixol",
    "Fluvoxamina",
    "Gabapentina",
    "Galantamina",
    "Haloperidol",
    "Halotano",
    "Hidrato de cloral",
    "Hidroclorbezetilamina",
    "Hidroxidiona",
    "Homofenazina",
    "Imicloprazina",
    "Imipramina",
    "Imipraminóxido",
    "Iproclozida",
    "Isocarboxazida",
    "Isoflurano",
    "Isopropil-crotonil-uréia",
    "Lacosamida",
    "Lamotrigina",
    "Leflunomida",
    "Levetiracetam",
    "Levomepromazina",
    "Levomilnaciprana",
    "Lisurida",
    "Lítio",
    "Loperamida",
    "Loxapina",
    "Lumiracoxibe",
    "Lurasidona",
    "Mavacanteno",
    "Maprotilina",
    "Meclofenoxato",
    "Mefenoxalona",
    "Mefexamida",
    "Memantina",
    "Mepazina",
    "Mesoridazina",
    "Metilnaltrexona",
    "Metilpentinol",
    "Metisergida",
    "Metixeno",
    "Metopromazina",
    "Metoxiflurano",
    "Mianserina",
    "Milnaciprana",
    "Miltefosina",
    "Minaprina",
    "Mirtazapina",
    "Misoprostol",
    "Moclobemida",
    "Molnupiravir",
    "Moperona",
    "Naloxona",
    "Naltrexona",
    "Nefazodona",
    "Nialamida",
    "Nitrito de isobutila",
    "Nitrito de isopentila",
    "Nitrito de isopropila",
    "Nomifensina",
    "Nortriptilina",
    "Noxiptilina",
    "Olanzapina",
    "Opipramol",
    "Oxcarbazepina",
    "benoxinato",
    "Oxibuprocaína",
    "Oxifenamato",
    "Oxipertina",
    "Paliperidona",
    "Parecoxibe",
    "Paroxetina",
    "Penfluridol",
    "Perfenazina",
    "Pergolida",
    "propericiazina",
    "Periciazina",
    "Pimozida",
    "Pipamperona",
    "Pipotiazina",
    "Pramipexol",
    "Pregabalina",
    "Primidona",
    "Proclorperazina",
    "Promazina",
    "Propanidina",
    "Propiomazina",
    "Propofol",
    "Protipendil",
    "Protriptilina",
    "Proximetacaina",
    "Quetiapina",
    "Ramelteona",
    "Rasagilina",
    "Reboxetina",
    "Ribavirina",
    "Rimonabanto",
    "Risperidona",
    "Rivastigmina",
    "Rofecoxibe",
    "Ropinirol",
    "Rotigotina",
    "Rufinamida",
    "Selegilina",
    "Sertralina",
    "Sevoflurano",
    "Sulpirida",
    "Sultoprida",
    "Tacrina",
    "Teriflunomida",
    "Tetrabenazina",
    "Tetracaína",
    "Tiagabina",
    "Tianeptina",
    "Tiaprida",
    "Tioproperazina",
    "Tioridazina",
    "Tiotixeno",
    "Tolcapona",
    "Topiramato",
    "Tranilcipromina",
    "Trazodona",
    "Triclofós",
    "Trifluoperazina",
    "Trifluperidol",
    "Trimipramina",
    "Troglitazona",
    "Valdecoxibe",
    "Valproato sódico",
    "Venlafaxina",
    "Veraliprida",
    "Vigabatrina",
    "Vilazodona",
    "Vortioxetina",
    "Ziprasidona",
    "Zotepina",
    "Zuclopentixol",
  ],
  C2: [
    "Acitretina",
    "Adapaleno",
    "Bexaroteno",
    "Isotretinoína",
    "Tretinoína",
  ],
  C3: [
    "talidomida",
    "Ftalimidoglutarimida",
    "Lenalidomida",
    "Pomalidomida",
  ],
  C5: [
    "Androstanolona",
    "Bolasterona",
    "Boldenona",
    "Cloroxomesterona",
    "Clostebol",
    "Deidroclormetiltestosterona",
    "Drostanolona",
    "Estanolona",
    "Estanozolol",
    "Etilestrenol",
    "Fluoximesterona",
    "fluoximetiltestosterona",
    "Formebolona",
    "Gestrinona",
    "Mesterolona",
    "Metandienona",
    "metandrostenolona",
    "Metandranona",
    "Metandriol",
    "Metenolona",
    "Metiltestosterona",
    "Mibolerona",
    "Nandrolona",
    "Noretandrolona",
    "Oxandrolona",
    "Oximesterona",
    "Oximetolona",
    "deidroepiandrosterona",
    "DHEA",
    "Prasterona",
    "Somapacitana",
    "Somatrogona",
    "hormônio do crescimento humano",
    "Somatropina",
    "Testosterona",
    "Trembolona",
  ],
};
